import { FaFacebook, FaInstagram, FaLinkedin } from "react-icons/fa";

import styles from "./Footer.module.css";

function Footer() {
  return (
    <footer className={styles.footer}>
      <ul className={styles.social_list}>
        <li>
          <FaFacebook />
        </li>
        <li>
          <FaInstagram />
        </li>
        <li>
          <FaLinkedin />
        </li>
      </ul>
      <p className={styles.copy_right}>
        <span>PetShop Catarina</span>
      </p>
      <a
        target="_blank"
        rel="noreferrer noopener"
        href="https://everton-fernandes.github.io/portifolio/"
        className={styles.create}
      >
        Feito por Everton Fernandes. ©2024. Todos os direitos reservador
      </a>
    </footer>
  );
}

export default Footer;
